<template>
  <div class="aulas-agendadas-not-found">
    <div :class="['aulas-agendadas-empty-warning', { center }]">
      <img src="~assets/warning.svg" alt="">

      <span>{{ title }}</span>
    </div>

    <p>{{ description }}</p>
  </div>
</template>

<script>

export default {
  props: {
    title: String,
    description: String,
    center: String
  },
}
</script>

<style scoped>
.aulas-agendadas-not-found {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.aulas-agendadas-not-found>p {
  color: #0F0E0E;
  font-size: 1rem;
  font-weight: 600;
}

.aulas-agendadas-empty-warning {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.aulas-agendadas-empty-warning>span {
  color: #0F0E0E;
  font-size: 1.5rem;
  font-weight: 700;
}

.center {
  justify-content: center;
}
</style>
